import { render } from "./Plan_Suscripcion.vue?vue&type=template&id=b723e16e"
import script from "./Plan_Suscripcion.vue?vue&type=script&lang=js"
export * from "./Plan_Suscripcion.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__